module.exports = __webpack_public_path__ + "img/118.34a3c724.jpg";